export const LoginMessages = {
    ANAUTHORIZED: {
      Type: "danger",
      Message: "Έχετε αποσυνδεθεί",
      Details: "Αυτό συνέβη επειδή προσπαθήσατε να αποκτήσετε πρόσβαση σε μια σελίδα που δεν έχετε εξουσιοδότηση",
    },
    SIGNOUT: {
      Type: "success",
      Message: "Έχετε αποσυνδεθεί",
      Details: "Μπορείτε να συνδεθείτε ξανά χρησιμοποιώντας την παρακάτω φόρμα",
    },
    REGISTERED: {
      Type: "success",
      Message: "Ο λογαριασμός σας είναι έτοιμος, μπορείτε να συνδεθείτε τώρα",
      Details: false,
    },
    AUTHERROR: {
      Type: "danger",
      Message: "Σφάλμα ελέγχου ταυτότητας",
      Details: null,
    },
    UNAVAILABLE: {
      Type: "danger",
      Message: "Η υπηρεσία δεν είναι διαθέσιμη.",
      Details: "Εάν το πρόβλημα παραμένει, επικοινωνήστε με το διαχειριστή του συστήματος σας",
    },
    TIMEOUT: {
      Type: "danger",
      Message: "Η συνεδρία σας έχει λήξει",
      Details: "Μπορείτε να συνδεθείτε ξανά χρησιμοποιώντας την παρακάτω φόρμα",
    },
    RESSETPASS: {
      Type: "success",
      Message: "Ο κωδικός ενημερώθηκε με επιτυχία",
      Details: "Μπορείτε να συνδεθείτε ξανά με τον καινούριο κωδικό χρησιμοποιώντας την παρακάτω φόρμα",
    },
  };
  